import baseService from "./base.service";

export type Contact = {
  id: number;
  name: string;
  email?: string | null;
  created_date: string;
};

export type CreateContactRequest = {
  name: string;
  email?: string | null;
};

export type UpdateContactRequest = {
  name: string;
  email?: string | null;
};

export const getContacts = async (): Promise<Contact[]> => {
  const response = await baseService.get("/contact");
  return response.data;
};

export const createContact = async (
  data: CreateContactRequest,
): Promise<Contact> => {
  const response = await baseService.post("/contact", data);
  return response.data;
};

export const updateContact = async (
  id: number,
  data: UpdateContactRequest,
): Promise<Contact> => {
  const response = await baseService.put(`/contact/${id}`, data);
  return response.data;
};

export const deleteContact = async (id: number): Promise<void> => {
  await baseService.delete(`/contact/${id}`);
};